// extracted by mini-css-extract-plugin
module.exports = {"root":"w_bJ","full-width":"w_cs","fullWidth":"w_cs"};